module.exports = __webpack_public_path__ + "img/atlas-logo.cf58a8a7.png";